exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mix-board .mix-title[data-v-40b63c88]{line-height:0.15625rem}.mix-board .mix-title .title-name[data-v-40b63c88]{box-sizing:border-box;color:#9B9B9B;font-weight:500}.mix-board .title-value[data-v-40b63c88]{border-radius:0 0.08333rem 0.08333rem 0;color:#222;font-size:0.09375rem;font-weight:700;padding:0.05208rem 0}\n", ""]);

// exports
